import React, { useState, useRef } from "react";
import "@egjs/react-flicking/dist/flicking.css";
import VideoTestimonial from "pages/iniciativas/VideoTestimonial";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/free-mode";
import "swiper/css";
import "swiper/css/navigation";
import { FreeMode, Navigation } from "swiper/modules";
import * as Text from "@/components/text";
import useWindowSize from "@/hooks/useWindowSize";
import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/outline";
import { localeTexts } from "@/utils/locale";

export default function BehindTheScenes({ data, locale }) {
  const windowSize = useWindowSize();
  const beforeRef = useRef(null);
  const afterRef = useRef(null);
  const [slideIndex, setIndex] = useState(0);

  return (
    <div className="flex items-center justify-center bg-neutral-50">
      <button
        ref={beforeRef}
        className="absolute left-10 hidden h-fit border-2 border-black p-4 hover:bg-black hover:text-white lg:flex"
      >
        <ArrowLeftIcon className="h-4 w-4" />
      </button>
      <div className="amb-container py-4">
        <Text.Title
          as="p"
          className="mb-6 w-full text-xl font-bold md:text-2xl"
        >
          {localeTexts[locale].common.behindTheScenes}
        </Text.Title>
        <Swiper
          spaceBetween={10}
          onActiveIndexChange={({ realIndex }) => {
            setIndex(realIndex || 0);
          }}
          freeMode={windowSize.width <= 900 ? true : false}
          slidesPerView={
            windowSize.width <= 460 ? 1.2 : windowSize.width <= 900 ? 3.1 : 4
          }
          modules={[FreeMode, Navigation]}
          navigation={{
            nextEl: afterRef.current,
            prevEl: beforeRef.current,
          }}
        >
          {data?.map((item, i) => (
            <SwiperSlide key={i} className="h-full w-full">
              <VideoTestimonial urlVideo={item?.url} />
              <div className="w-full text-left">
                <Text.Paragraph as="p" className="font-semibold">
                  {item?.title}
                </Text.Paragraph>
                <Text.Paragraph>{item?.subtitle}</Text.Paragraph>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <button
        ref={afterRef}
        className="absolute right-10 hidden h-fit border-2 border-black p-4 hover:bg-black hover:text-white lg:flex"
      >
        <ArrowRightIcon className="h-4 w-4" />
      </button>
    </div>
  );
}